module.exports = __webpack_public_path__ + "static/media/tick.eb69c905.mp3";